import { useHealth } from "../hooks/useHealth";

export function VersionUpdateBanner() {
  const { isStale } = useHealth();
  if (!isStale) return null;

  return (
    <div className="version-banner" role="status">
      <span className="version-banner__text">A new version is available.</span>
      <button
        type="button"
        className="version-banner__button"
        onClick={() => window.location.reload()}
      >
        Refresh
      </button>
    </div>
  );
}
